import { IS_MOBILE } from '@constants/global.js';
import _State from './_State.js';

const DrawerState = _State('drawer', 'setDrawer', {
  isOpen: false,
  isExpanded: false,
  width: window.innerWidth / 3,
  originalWidth: IS_MOBILE() ? window.innerWidth : window.innerWidth / 3,
  minWidth: 400,
  maxHeight: window.innerHeight - 60,
  snapPoints: [100, 300, window.innerHeight - 60],
  currentContent: 'none',
  contentList: {},
  previousContent: '',
  selectedButtons: {
    comments: false,
    details: false,
    quotation: false,
    report: false,
  },
});

DrawerState.toggleDrawer = function (bool) {
  return this.setDrawer({
    ...this.drawer,
    isOpen: bool,
  });
};

DrawerState.toggleExpand = function () {
  return this.setDrawer({
    ...this.drawer,
    isExpanded: !this.drawer.isExpanded,
  });
};

DrawerState.setOriginalWidth = function (newWidth) {
  this.setDrawer({
    ...this.drawer,
    originalWidth: newWidth,
  });
  return newWidth;
};

DrawerState.setWidth = function (newWidth) {
  this.setDrawer({
    ...this.drawer,
    width: newWidth,
  });
  return newWidth;
};

DrawerState.setContent = function (contentKey) {
  return this.setDrawer({
    ...this.drawer,
    currentContent: contentKey,
  });
};

DrawerState.addContent = function (content, key) {
  const newContentList = {
    ...this.drawer.contentList,
    [key]: content,
  };

  return this.setDrawer({
    ...this.drawer,
    contentList: newContentList,
  });
};

DrawerState.getContent = function (key) {
  return this.drawer.contentList[key];
};

DrawerState.updateMaxHeight = function () {
  return this.setDrawer({
    ...this.drawer,
    maxHeight: window.innerHeight - 60,
    snapPoints: [100, 300, window.innerHeight - 60],
  });
};

DrawerState.setSelectedButton = function (buttonName, isSelected) {
  const newSelectedButtons = {
    ...this.drawer.selectedButtons,
    [buttonName]: isSelected,
  };

  return this.setDrawer({
    ...this.drawer,
    selectedButtons: newSelectedButtons,
  });
};

DrawerState.setPreviousContent = function (content) {
  return this.setDrawer({
    ...this.drawer,
    previousContent: content,
  });
};

DrawerState.getPreviousContent = function () {
  return this.drawer.previousContent;
};

DrawerState.resetSelectedButtons = function () {
  return this.setDrawer({
    ...this.drawer,
    selectedButtons: {
      comments: false,
      details: false,
      quotation: false,
      report: false,
    },
  });
};

export default DrawerState;
